import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import './Carregando.css';

const Carregando = () => (
  <div className="loading-spinner">
    <FaSpinner className="spinner-icon" />
  </div>
);

export default Carregando;
